// Use Cases section content
export const useCases = [
  {
    eyebrow: 'Sales Teams',
    headline: 'Generate Winning Pitches in Seconds',
    description: 'Feed SlideFactory your product data, customer context, and sales playbook. Get perfectly tailored sales presentations that close deals. Update all decks instantly when products or pricing change.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop',
    imageAlt: 'Sales Enablement',
    cta: { label: 'Learn More', href: '#cta' },
    layout: 'image-left'
  },
  {
    eyebrow: 'HR & Training',
    headline: 'Scale Your Training Programs',
    description: 'Transform documentation, policies, and procedures into engaging training presentations. Keep content current across all departments automatically. Reduce manual content creation by 90%.',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=600&fit=crop',
    imageAlt: 'Training & Onboarding',
    cta: { label: 'Learn More', href: '#cta' },
    layout: 'image-right'
  },
  {
    eyebrow: 'Business Intelligence',
    headline: 'Turn Data into Stories',
    description: 'Connect to your data sources and generate executive presentations automatically. Quarterly reviews, KPI updates, and board decks - all generated with consistent formatting and up-to-date numbers.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
    imageAlt: 'Reporting & Analytics',
    cta: { label: 'Learn More', href: '#cta' },
    layout: 'image-left'
  },
  {
    eyebrow: 'Developers & Automation',
    headline: 'Build Presentation Workflows',
    description: 'RESTful API and N8N nodes make integration straightforward. Generate presentations programmatically, embed in your applications, or create custom automation pipelines with full API documentation.',
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&h=600&fit=crop',
    imageAlt: 'Developer Integration',
    cta: { label: 'View API Docs', href: 'https://docs.slidefactory.app' },
    layout: 'image-right'
  }
]
